export default __webpack_public_path__ + "static/media/sample_before.65a0e83a.jpg";